<template>
  <div class="user-location" v-if="country">
    <div v-if="!hideFlag" class="user-location-country" />
    <span>{{ country }}</span>
  </div>
</template>

<script>
export default {
  name: 'Location',
  props: {
    country: String,
    hideFlag: Boolean,
  },
}
</script>

<style lang="scss">
.user-location {
  @include flexCenter;

  span {
    font-weight: 400;
    font-size: 15px;
    line-height: 157.5%;
    color: #474747;
  }

  img {
    margin-right: 8px;
  }

  @include PC {
    font-size: 12px;
  }

  .user-location-country {
    width: 13px;
    height: 13px;
    min-height: 13px;
    flex-shrink: 0;
    margin-right: 5px;

    background: $lightGray;
    border-radius: 50%;
  }
}
</style>
